const cancelUploadMealPopUpTranslations = {
  title: "Decline Meal Uploading",
  description: "Are you sure you want to decline uploading your meal",
  actionButtons: {
    cancel: "Cancel",
    submit: "Decline & Proceed",
  },
};

export default cancelUploadMealPopUpTranslations;
